// import styles
import '../scss/main.scss';
// import service worker
import swUrl from '../serviceworker';
// application imports
import $ from 'jquery';
import * as ko from 'knockout';
import {App} from './app.ts';

// register service worker
const isLocalDevHost = ['localhost', '127.0.0.1'].includes(window.location.hostname);

if ('serviceWorker' in navigator && !isLocalDevHost) {
    window.addEventListener('load', function () {
        'use strict';
        console.debug('main: registering service worker with url', swUrl);
        navigator.serviceWorker
            .register(`${swUrl}`, {
                scope: '/drc/app'
            })
            .then(function (registration) {
                // Registration was successful
                console.debug('main: service worker registration successful with scope: ', registration.scope);
            }, function (err) {
                // registration failed :(
                console.error('main: service worker registration failed: ', err);
            });
    });
} else if ('serviceWorker' in navigator && isLocalDevHost) {
    console.debug('main: skipping service worker registration on local dev host');
}

// initialize the app
$(function () {
    'use strict';
    console.info('main: initializing ÖAMTC Reise-Checkliste ...');
    try {
        ko.options.deferUpdates = true;
        new App().init()
            .then(() =>
                console.info('main: ÖAMTC Reise-Checkliste succesfully initialized'))
            .catch(err =>
                console.error("main: cannot initialize app", err));
    } catch (err) {
        console.error("main: cannot initialize app", err);
    }
});
